import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import { Image, Text, View } from 'react-native';
import ProjectDocument from '../../../../../Common/DTO/ProjectDocument';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import {styles} from "./DocumentsViewStyle";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface DocumentsViewProps {
    projectDocuments: ProjectDocument[];
    documentsLegalInfoText : any;
}

export const DocumentsView = ({projectDocuments, documentsLegalInfoText}: DocumentsViewProps) => {
    const {isMobile} = useWindowSizeContext();

    return (
      <View style={styles.page}>
        <TranslationView style={styles.title}>documents</TranslationView>
        <View style={isMobile ?  styles.documentsCol : styles.documentsRow}>
          {projectDocuments.map((document: ProjectDocument, index: number) => {
            if (Helpers.getCurrentLanguage() !== "EN")
              if (document.language !== Helpers.getCurrentLanguage()) return null;
            return (
              <div style={{cursor: 'pointer'}} key={"document-view-"+index}>
                <View key={index} style={[styles.row, isMobile && styles.mobileRow]}>
                    <Image source={require('./assets/file-pdf.png')} style={styles.documentImage}/>
                    <View style={{width: '80%'}}>
                        <a href={document.url} style={{textDecoration: 'none'}} rel="noopener noreferrer" target='_blank'>
                            <Text style={[styles.documentTitle, {fontSize: isMobile ? 16: 20}]}>
                              {document.language != null ? `${Helpers.getCorrectTranslation(document.title)} - ${document.language}` : `${Helpers.getCorrectTranslation(document.title)}`}
                            </Text>
                        </a>
                    </View>

                </View>
              </div>
            )
          })}
          <Text style={styles.infoText}>{Helpers.getCorrectTranslation(documentsLegalInfoText)}</Text>
        </View>

      </View>

    );
}

export default DocumentsView;